import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { validateForm } from './utils/ValidateForm';
import { urlViewFacturacionAP } from "../../constants/urls";
import ContainerApFacturacion from "./ContainerApFacturacion";
import FormularioContratante from './FormularioContratante';
import LoadingScreen from "react-loading-screen";
import logo from "assets/img/logo/logo_aig_login-2.png";

const infoIds = {
    codigoCedulaStr: "1",
    codigoRucStr: "2",
    codigoPasaporteStr: "3",
    codigoCedulaNum: 1,
    codigoRucNum: 2,
    codigoPasaporteNum: 3
}
const DatosFacturacion = (props) => {
    const ambienteAplicacion = "WEB";
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const idCarrito = queryParams.get("id");

    const [loading, setLoading] = useState(true);
    const [carDatosContratante, setCarDatosContratante] = useState(false);
  


    useEffect(() => {
        const fetchData = async () => {
            try {
                   setLoading(true);
                const dataFacturacion = await recuperarFacturacion(idCarrito);
                if (dataFacturacion && dataFacturacion.carDatosContratante) {
                    setCarDatosContratante(dataFacturacion.carDatosContratante);
                } else if (dataFacturacion) {
                    let contratante = null;
                    const tipoContratanteActivo = dataFacturacion.tipoContratanteActivo ? String(dataFacturacion.tipoContratanteActivo) : "";

                    if (tipoContratanteActivo === "1" || tipoContratanteActivo === "3") {
                        if (dataFacturacion.datosContratantePersona) {
                            contratante = { ...dataFacturacion.datosContratantePersona };
                            if (!contratante.tipoIdentificacion) {
                                contratante.tipoIdentificacion = tipoContratanteActivo;
                            }
                        }
                    } else if (tipoContratanteActivo === "2") {
                        if (dataFacturacion.datosContratanteEmpresa) {
                            contratante = { ...dataFacturacion.datosContratanteEmpresa };
                            if (!contratante.tipoIdentificacion) {
                                contratante.tipoIdentificacion = "2";
                            }
                        }
                    } else {
                        // Fallback de seguridad en caso de que tipoContratanteActivo no esté definido o tenga valor inesperado
                        if (dataFacturacion.datosContratanteEmpresa && dataFacturacion.datosContratanteEmpresa.cliIdentificacion) {
                            contratante = { ...dataFacturacion.datosContratanteEmpresa };
                            if (!contratante.tipoIdentificacion) {
                                contratante.tipoIdentificacion = "2";
                            }
                        } else if (dataFacturacion.datosContratantePersona) {
                            contratante = { ...dataFacturacion.datosContratantePersona };
                            if (!contratante.tipoIdentificacion) {
                                contratante.tipoIdentificacion = "1";
                            }
                        }
                    }

                    if (contratante) {
                        // Homologar cliProvincia y cliCiudad a provincia y ciudad para que FormularioContratante los inicialice
                        if (contratante.cliProvincia && !contratante.provincia) {
                            contratante.provincia = contratante.cliProvincia;
                        }
                        if (contratante.cliCiudad && !contratante.ciudad) {
                            contratante.ciudad = contratante.cliCiudad;
                        }

                        // Inyectar ubicación solo si el contratante no tiene provincia ni ciudad definidas
                        if (dataFacturacion.datosUbicacion) {
                            const tieneProvincia = contratante.provincia || contratante.cliProvincia;
                            if (!tieneProvincia && dataFacturacion.datosUbicacion.provincia) {
                                contratante.provincia = dataFacturacion.datosUbicacion.provincia.value || dataFacturacion.datosUbicacion.provincia;
                            }
                            const tieneCiudad = contratante.ciudad || contratante.cliCiudad;
                            if (!tieneCiudad && dataFacturacion.datosUbicacion.ciudad) {
                                contratante.ciudad = dataFacturacion.datosUbicacion.ciudad.value || dataFacturacion.datosUbicacion.ciudad;
                            }
                        }
                        setCarDatosContratante(contratante);
                    }
                }
                  setLoading(false);
            } catch (error) {
                console.error("Error al recuperar datos de facturación:", error);
            } finally {
                 setLoading(false);
            }
        };

        fetchData();
    }, [idCarrito]);

    const recuperarFacturacion = async (idCarrito) => {
        const body = { id: idCarrito };
        setLoading(true)
        try {
            const response = await fetch(urlViewFacturacionAP, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body)
            });

            const json = await response.json();
            setLoading(false)
            if (json.transaccion) {
                return json.facturacion;
            } else {
                
                console.error("No se pudo recuperar la facturación:", json.mensaje);
                return {};
            }

        } catch (error) {
            console.error("Error en recuperarFacturacion:", error);
            return {};
        }
    };



    return (
        <ContainerApFacturacion
            paso={'Slip'}
            titulo={props.datosCotizador.titulo}
        >
            <main class="cr-app bg-light">
                <div class="cr-content container-fluid">
                    <div className="container-body-spaces">
                        <LoadingScreen
                            loading={loading}
                            bgColor="#f1f1f1"
                            spinnerColor="#001871"
                            textColor="#676767"
                            logoSrc={logo}
                            text="Obteniendo datos..."
                        >                        
                            <FormularioContratante
                                setLoading={setLoading}
                                urlRegresar={props.datosCotizador.urlRegresar}
                                urlContinuar={props.datosCotizador.urlSiguiente}
                                carDatosContratante={carDatosContratante}
                                idCarrito={idCarrito}
                            />
                            
                        </LoadingScreen>
                    </div>
                </div>
            </main>

        </ContainerApFacturacion>

    );
};

export default DatosFacturacion;
